import { Comment } from "./Comment";
import { CommentForm } from "./CommentForm";
import { CommentList } from "./CommentList";
import { CommentPagination } from "./CommentPagination";
import { CommentTime } from "./CommentTime";

export const Comments = {
  Item: Comment,
  Form: CommentForm,
  List: CommentList,
  Pagination: CommentPagination,
  Time: CommentTime,
};

export { EntityComments } from "./EntityComments";
export { DeleteCommentConfirmation } from "./DeleteCommentConfirmation";
